var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Doc",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312.77 303.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#006aea;}.cls-2{fill:#95c3fa;}.cls-3{fill:#edf5f7;}.cls-3,.cls-4,.cls-5{stroke:#fff;stroke-miterlimit:10;}.cls-4{fill:#dce5e5;}.cls-5{fill:#f4f4f4;}.cls-6{fill:#196c8e;}.cls-7{fill:#75b2fc;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bg-Circles"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 200.31,
    cy: 365.32,
    rx: 21.02,
    ry: 22.08,
    transform: "translate(-373.45 173.63) rotate(-46.14)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Bg-Circles-2",
    "data-name": "Bg-Circles"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 284.13,
    cy: 248.32,
    rx: 109.67,
    ry: 115.18,
    transform: "translate(-263.34 198.14) rotate(-46.14)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Docs2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "275.46 288.05 219.81 299.45 202.23 218.46 257.88 207.06 275.46 288.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "183.84 282.33 105.51 260.28 125.13 146.74 203.46 168.79 183.84 282.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "227.72 91.74 172.07 103.15 154.49 22.16 210.14 10.76 227.72 91.74"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Docs1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73.2 254.74 176.86 244.09 164.88 92.32 61.22 102.97 73.2 254.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "231.28 174.42 312.12 121.81 251.4 0.72 170.56 53.32 231.28 174.42"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Doc-Face"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.11 134.48 150.16 126.72 149.71 122.99 87.67 130.75 88.11 134.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "97.48 146.68 138.2 141.58 137.78 138.08 97.06 143.18 97.48 146.68"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 97.04,
    cy: 171.1,
    rx: 5.96,
    ry: 6.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 144.98,
    cy: 169.19,
    rx: 5.36,
    ry: 5.47
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.28,292.7a15.61,15.61,0,0,0-19.11-.42c0,.63,0,1.26,0,1.89a16.21,16.21,0,0,1,9.26-2.77c8.7.22,13.62,8,14.06,8.69Z",
    transform: "translate(-171.56 -82.99)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Bg-Circles-3",
    "data-name": "Bg-Circles"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 463.72,
    cy: 158.54,
    rx: 16.91,
    ry: 16.44,
    transform: "translate(-97.18 373.18) rotate(-56.27)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Bg-Circles-4",
    "data-name": "Bg-Circles"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 207.99,
    cy: 139.94,
    rx: 8.81,
    ry: 9.25,
    transform: "translate(-208.59 109.95) rotate(-46.14)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/Docs.4eb1dbde5cc3798455f0e7aa87e4713a.svg";
export { ForwardRef as ReactComponent };